;(() => {
  document.addEventListener("search-map:mount", (event) => {
    window.HB.initMapTypesSwitcher(event.detail.gmap)
  })
})()
